import React, { useEffect, useRef, useState } from 'react'
import styles from "./Toppanel.module.css"
import styles1 from "../pages/Dashboardcomponents/Environmentpanel.module.css"
import { Link } from 'react-router-dom'
import { ReactComponent as Icon } from "../Icon/create_new_file.svg"
import { ReactComponent as Icon1 } from "../Icon/createnewfile.svg"
import { create_project_file_Api, delete_project_file_Api, renameProjectFileApi } from '../dashboardapi'
import { IconButton, useToast, Tooltip, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, Box, useDisclosure, Button, Spinner } from '@chakra-ui/react'
import CustomModal from "../pages/Dashboardcomponents/Modal"

const Toppanel = (props) => {
    const [filetodelete, setFiletoDelete] = useState("")
    const [groupfiles, setGroupFiles] = useState("");
    const fileInputRef = useRef(null);
    const [openGroups, setOpenGroups] = useState({ tex: [] });
    const [renamingFile, setRenamingFile] = useState(null);
    const [newFileName, setNewFileName] = useState("");
    const [contextMenu, setContextMenu] = useState(null);
    const [fileUploadShow, setFileUploadShow] = useState(false);
    const [dragging, setDragging] = useState(false);
    const [showMore, setShowMore] = useState(false);
    const [currentFileIndex, setCurrentFileIndex] = useState(-1);
    // const [name, setName] = useState([]);
    const toast = useToast();
    const moreref = useRef();

    useEffect(() => {
        const moreClick = (e) => {
            if (moreref.current && !moreref.current.contains(e.target) && !e.target.closest(".morebtn")) {
                setCurrentFileIndex(-1);
            }
        }

        document.addEventListener("click", moreClick);
        return () => document.removeEventListener("click", moreClick)
    })


    const {
        isOpen: alertOpen,
        onToggle: onalertToogle,
        onClose: onalertClose,
    } = useDisclosure();

    const handleFiles = async (files) => {
        const fileslist = Array.from(files);
        toast({
            title: "Uploading Files",
            description: "File uploading in progress",
            status: "loading",
            isClosable: true,
        })
        try {
            let result = await create_project_file_Api(props.projectid, fileslist);
            if (result.data) {
                toast.closeAll();
                toast({
                    title: "Files uploaded",
                    description: "Files uploaded successfully",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"

                })
                props.getprojectfiles();
            } else {
                let error = result.error.message || "An error Occurred"
                toast({
                    title: "Problem uploading files",
                    description: error,
                    duration: 2000,
                    isClosable: "true"
                })
            }
        } catch (error) {
            toast({
                title: "Problem creating file",
                description: error,
                duration: 2000,
                isClosable: "true"
            })
        }
    };


    const handleClick = () => {
        //  // Trigger file input click
        setFileUploadShow(true)
    };

    const triggerInputClick = () => {
        fileInputRef.current.click();
    }

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true); // Highlight the area when dragging files
    };

    const handleDragLeave = () => {
        setDragging(false); // Remove highlight when leaving
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false); // Remove highlight when dropping files
        const files = e.dataTransfer.files;
        handleFiles(files); // Handle dropped files
    };


    const createFile = async () => {
        let count = 0;
        let num;
        let regex = /^main(\d+)*\.tex/g
        if (props.projectfiles) {
            props.projectfiles.forEach(element => {
                let res
                while ((res = regex.exec(element.name)) !== null) {
                    if (res[1] === undefined) {
                        count = 1;

                    } else {
                        num = parseInt(res[1])
                        num = Math.max(num)
                        count = num + 1;
                    }
                }
            }
            )
        }
        let name = `main${count}.tex`

        try {
            // Attempt to create the new file
            let result = await create_project_file_Api(props.projectid, name);
            if (result.data) {
                toast({
                    title: "File Created",
                    description: "Tex file created successfully",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"

                })
                props.getprojectfiles();
            } else {
                let error = result.error.Message || "An error occurred";
                toast({
                    title: "Problem creating file",
                    description: error,
                    duration: 2000,
                    isClosable: "true"

                })
            }
        } catch (error) {
            toast({
                title: "Problem creating file",
                description: "tex file not created, try again later.",
                status: 'error',
                duration: 2000,
                isClosable: "true"

            })
        }
    };

    const handleDelete = async (projectid, fileid) => {
        toast({
            title: "Deleting file",
            description: "File deletion in progress",
            status: "loading",
            isClosable: "true"

        })
        try {
            let result = await delete_project_file_Api(projectid, fileid);
            if (result.data) {
                toast.closeAll();
                toast({
                    title: "File Deleted",
                    description: "File deleted Successfully",
                    status: "success",
                    duration: 2000,
                    isClosable: "true"

                })
                props.getprojectfiles()
            } else {
                let error = result.error.message || "An error occurred";
                toast({
                    title: "Problem creating file",
                    description: error,
                    duration: 2000,
                    isClosable: "true"

                })
            }
        } catch (e) {
            toast({
                title: "Problem deleting file",
                description: "tex file not deleted, try again later.",
                status: 'error',
                duration: 2000,
                isClosable: "true"

            })
        }
    }

    const handleDeleteClick = (items) => {
        setFiletoDelete(items);
        onalertToogle();
    }

    const toggleGroup = (extension) => {
        setOpenGroups(prevState => ({
            ...prevState,
            [extension]: !prevState[extension], // Toggle the open/close state
        }));

    };

    useEffect(() => {
        if (!props.projectfiles) {
            console.log("No project files available");
            return null; // Or return a loading state
        }
        const group = props.projectfiles?.reduce((groups, file) => {
            const extension = file.name.split(".").pop()
            if (!groups[extension]) groups[extension] = [];
            groups[extension].push(file);
            return groups;
        }, [])

        const preferredOrder = ["tex", "bib", "jpg", "jpeg", "png", "eps", "pdf"];

        let sorted_group = Object.entries(group).sort((a, b) => {
            let typea = preferredOrder.indexOf(a[0]);
            let typeb = preferredOrder.indexOf(b[0]);
            if (typea !== -1 && typeb !== -1) {
                return typea - typeb;
            }
            if (typea !== -1) return -1;
            if (typeb !== -1) return 1;
            return a[0].localeCompare(b[0])
        })
        setGroupFiles(sorted_group);

    }, [props.projectfiles])

    // console.log(groupfiles);


    // const handleRightClick = (e, items) => {
    //     e.preventDefault();
    //     setContextMenu({ x: e.pageX, y: e.pageY, items });
    // }

    const handleRenameClick = (file) => {
        setRenamingFile(file.name);
        setNewFileName(file.name);
    };

    const handleRenameSubmit = (event, file) => {
        event.preventDefault();
        if (newFileName.trim() && newFileName !== file.name) {
            handleRename(file, newFileName);
        }
        setRenamingFile(null);
    };

    const handleRename = async (file, newFileName) => {
        toast({
            title: "Renaming file",
            description: "Please wait..",
            status: 'info',
            isClosable: true,
            icon: (
                <Spinner
                    thickness="4px"
                    emptyColor="gray.200"
                    color="blue.500"
                    size="sm"
                />
            ),
        })
        let response = await renameProjectFileApi(file.project_uuid, file.file_uuid, newFileName);
        if (response.data) {
            props.getprojectfiles();
            toast.closeAll();
        } else {
            toast({
                title: "Problem renaming file",
                description: "There is a problem renaming file please try again later.",
                status: 'error',
                isClosable: true,
                duration: 2000,
            })
        }
    }

    const handleShowMore = (i, items) => {
        if (currentFileIndex !== items.file_uuid) {
            setCurrentFileIndex(-1)
            setCurrentFileIndex(items.file_uuid)
        } else {
            setCurrentFileIndex(-1);
        }
    }


    return (
        <div className={styles.toppanel_outer}>
            <div className={styles.toppanel_header}>
                <Tooltip label={"Create tex file"}>
                    <IconButton className={styles.create_file} colorScheme="#323334" onClick={createFile}>
                        <Icon />
                    </IconButton>
                </Tooltip>
                <Tooltip label={"Import file"}>
                    <IconButton colorScheme="#323334" onClick={handleClick} icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-download" viewBox="0 0 16 16">
                        <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                        <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z" />
                    </svg>}>
                    </IconButton>
                </Tooltip>
                {/* <input
                    type='file'
                    name='project_name'
                    placeholder='Enter Project Name'
                    ref={fileInputRef}
                    style={{ display: 'none' }} // hide the file input
                    multiple
                    onClick={(e) => e.target.value = ""}
                    onChange={(e) => handleFiles(e.target.files)}
                /> */}
            </div>
            <div className={styles.toppanel_body}>
                <div className={styles.toppanel_content}>
                    {/* {props.projectfiles ? props.projectfiles.map((items, i) => (
                        <div key={i} style={{ width: "100%" }}>
                            <div key={i} style={{ width: "90%", display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
                                <Link reloadDocument={items.name.indexOf(".tex") || items.name.indexOf(".bib") > 0 ? true : false} to={"/" + props.projectid + "/" + items.name} key={i} className={styles.filelist}>
                                    <Tooltip label={items.name.length > 9 ? items.name : ""}>
                                        <div style={{ display: "flex", gap: "5px" }}><div><Icon1 /></div><p className={items.name === props.current_file ? styles.selected : ""}>{items.name.length > 9 ? items.name.slice(0, 9) + "..." : items.name}</p></div>
                                    </Tooltip>
                                </Link>
                                <Tooltip label={"Delete File"}>
                                    <div onClick={() => handleDeleteClick(items)}><button style={{ color: "#cccbd3" }}>X</button></div>
                                </Tooltip>
                            </div>
                        </div>
                    )) : ""} */}
                    {
                        groupfiles && groupfiles?.map((extension, index) => (
                            <div key={index} style={{ color: "#cccbd3", width: "100%" }}>
                                <div onClick={() => toggleGroup(extension[0])} style={{ backgroundColor: "#323334", color: "#cccbd3", fontWeight: "500", padding: "3px 10px 3px 10px", display: "flex", gap: "10px", cursor: "pointer" }}>
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="24"
                                        height="24"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        style={{
                                            transition: "transform 0.3s ease", // Smooth transition
                                            transform: openGroups[extension[0]] ? 'rotate(0deg)' : 'rotate(-90deg)' // Conditional rotation
                                        }}>
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M6 9l6 6l6 -6" />
                                    </svg>
                                    <h3>{extension[0].toUpperCase()} Files</h3>
                                </div>
                                {openGroups[extension[0]] &&
                                    extension[1]?.map((items, i) => (
                                        <div key={i} style={{ width: "100%" }}>
                                            <div key={i} style={{ width: "90%", display: 'flex', alignItems: "center", justifyContent: "space-between" }}>
                                                {/* <div style={{ display: "flex", gap: "5px" }}><div><Icon1 /></div><p className={items.name === props.current_file ? styles.selected : ""}>{items.name.length > 9 ? items.name.slice(0, 9) + "..." : items.name}</p></div> */}
                                                {renamingFile === items.name ? (
                                                    <form onSubmit={(e) => handleRenameSubmit(e, items)} className={styles.filelist}>
                                                        <input
                                                            type="text"
                                                            value={newFileName}
                                                            onChange={(e) => setNewFileName(e.target.value)}
                                                            autoFocus
                                                            onBlur={() => setRenamingFile(null)}
                                                            style={{ border: "1px solid #ccc", padding: "2px", borderRadius: "4px", backgroundColor: "#cccbd3", color: "#000" }}
                                                        />
                                                    </form>
                                                ) : (
                                                    <>
                                                        <Link reloadDocument={items.name.indexOf(".tex") || items.name.indexOf(".bib") > 0 ? true : false} to={"/" + props.projectid + "/" + items.name} key={i} className={styles.filelist}>
                                                            <Tooltip label={items.name}>
                                                                <p className={items.name === props.current_file ? styles.selected : ""}>
                                                                    {items.name}
                                                                </p>
                                                            </Tooltip>
                                                        </Link>
                                                        <Tooltip label={"More"}>
                                                            <div className='morebtn' style={{ height: "auto", width: "auto", display: 'flex', alignItems: "center", position: 'relative', padding: "5px 10px", cursor: 'pointer' }} onClick={() => handleShowMore(i, items)}><button style={{ color: "#cccbd3" }}>&#8942;</button>
                                                                {
                                                                    currentFileIndex !== -1 && currentFileIndex === items.file_uuid ? <div ref={moreref} className='more_option' style={{ position: "absolute", width: "fit-content", padding: "5px 10px", display: "flex", flexDirection: "column", alignItems: 'start', background: "#fff", zIndex: 10000, top: "30px", right: "25px", borderRadius: "6px" }}>
                                                                        <button onClick={() => handleRenameClick(items)} style={{ color: "#222" }}>Rename</button>
                                                                        <button onClick={() => handleDeleteClick(items)} style={{ color: "red" }}>Delete</button>
                                                                    </div> : null
                                                                }
                                                            </div>
                                                        </Tooltip>

                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>
                <Modal isOpen={alertOpen} onClose={onalertClose} isCentered>
                    <ModalOverlay >
                        <ModalContent>
                            <ModalHeader>
                                Alert
                            </ModalHeader>
                            <ModalCloseButton />
                            <ModalBody overflow="auto" padding="20px" style={{ borderTop: "1px solid gray" }}>
                                <Box style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                    <h1 style={{ fontWeight: "500" }}>
                                        {filetodelete.name}
                                    </h1>
                                    <p>
                                        Do you wish to delete the file ?
                                    </p>
                                </Box>
                                <Box mt="15px">
                                    <Button style={{ backgroundColor: "rgba(220,38,38,1)", color: "#fff" }} onClick={() => { handleDelete(filetodelete.project_uuid, filetodelete.file_uuid); onalertClose() }}> Delete </Button>
                                </Box>
                            </ModalBody>
                        </ModalContent>
                    </ModalOverlay>
                </Modal>
                {/* {contextMenu && (
                    <div
                        style={{
                            position: "absolute",
                            top: contextMenu.y,
                            left: contextMenu.x,
                            background: "#fff",
                            border: "1px solid #ccc",
                            boxShadow: "0px 2px 5px rgba(216, 206, 206, 0.2)",
                            padding: "0 5px",
                            zIndex: 1000,
                        }}
                        onMouseLeave={() => setContextMenu(null)}
                    >
                        <div
                            style={{ fontSize: "14px", padding: "5px", cursor: "pointer" }}
                            onClick={() => handleRenameClick(contextMenu.items)}
                        >
                            Rename
                        </div>
                    </div>
                )} */}
                <CustomModal show={fileUploadShow}>
                    <div className={styles1.modalouter} >
                        <div style={{ padding: '24px', borderRight: '0.6px solid #CCCBD3', width: '100%' }}>
                            <div style={{ display: "flex", width: "100%", justifyContent: "space-between" }}>
                                <div className={styles1.modalheader}>
                                    <p>Upload files</p>
                                </div>

                                <button onClick={() => setFileUploadShow(false)} style={{ padding: "5px 10px" }}>
                                    Close
                                </button>

                            </div>
                            <form className={styles1.formouter} method='POST' >
                                <div className={`${styles1.inputdiv} ${dragging ? styles1.dragging : ''}`} onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}>
                                    {dragging ? (
                                        // When dragging, show this content
                                        <div style={{ height: '133px' }}>
                                            Drop your files here
                                        </div>
                                    ) : (
                                        <>
                                            <p>
                                                <img src={process.env.PUBLIC_URL + "/images/Redesignpics/Dashboard/upload_img.png"} alt='' />
                                            </p>
                                            <div>Upload your files</div>
                                            <p>Drag and drop your files here or <a onClick={triggerInputClick} >choose files</a></p>
                                            <input
                                                type='file'
                                                name='project_name'
                                                placeholder='Enter Project Name'
                                                ref={fileInputRef}
                                                style={{ display: 'none' }} // hide the file input
                                                multiple
                                                onChange={(e) => handleFiles(e.target.files)}
                                                accept='.tex, .bib, .pdf, .png, .jpg, .jpeg, .dtx, .ins, .bst, .sty, .eps, .cls'
                                            />
                                        </>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </CustomModal>
            </div>
        </div>
    )
}

export default Toppanel